<template>
    <header class="container-fluid" style="height: 4rem;">
        <div class="row h-100">
            <div class="col-6 d-flex h-100">
                <slot name="header-left"></slot>
            </div>
            <div class="col-6 d-flex h-100">
                <slot name="header-right"></slot>
            </div>
        </div>
    </header>
</template>